import { render, staticRenderFns } from "./WidgetHotelsTop.vue?vue&type=template&id=eab9dd3c"
import script from "./WidgetHotelsTop.vue?vue&type=script&lang=js"
export * from "./WidgetHotelsTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports